/** Campaigns (plan E06-T05): each one, where it stands, and a way to set up a new one. */
import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { useState } from "react";
import { Page, Section, useApiQuery } from "../app/Page";
import { PhoneLineDialog, useHasLine } from "../app/PhoneLineDialog";
import { useCan } from "../app/session";
import { useFormat, useT } from "../i18n";
import { Button } from "../ui/Button";
import { Empty } from "../ui/states";
import { Table } from "../ui/Table";
import { CampaignStatus } from "./parts";

export function CampaignsPage() {
  const t = useT();
  const format = useFormat();
  const canCreate = useCan("campaigns:write");
  const campaigns = useApiQuery("campaigns", (api) => api.GET("/v1/campaigns", { params: { query: { limit: 100 } } }));
  const hasLine = useHasLine();
  const [needsLine, setNeedsLine] = useState(false);
  // V1.2-UX-T06: a campaign calls out, so without a phone line yet, how to get one comes first
  const create = canCreate && (hasLine === false ? (
    <Button onClick={() => setNeedsLine(true)}>
      <Plus size={16} aria-hidden="true" />
      {t("campaigns.new")}
    </Button>
  ) : (
    <Button asChild>
      <Link to="/campaigns/new">
        <Plus size={16} aria-hidden="true" />
        {t("campaigns.new")}
      </Link>
    </Button>
  ));
  return (
    <Page title={t("nav.campaigns")} description={t("campaigns.description")} actions={create}>
      <PhoneLineDialog open={needsLine} onOpenChange={setNeedsLine} />
      <Section query={campaigns}>
        {(page) =>
          page.data.length === 0 ? (
            <Empty title={t("campaigns.empty")}>
              <p>{t("campaigns.emptyBody")}</p>
              {create}
            </Empty>
          ) : (
            <Table
              caption={t("nav.campaigns")}
              rows={page.data}
              rowKey={(c) => c.id}
              columns={[
                {
                  header: t("campaigns.col.name"),
                  cell: (c) => (
                    <Link to="/campaigns/$campaignId" params={{ campaignId: c.id }} className="font-medium text-[var(--color-primary)] underline">
                      {c.name}
                    </Link>
                  ),
                },
                { header: t("campaigns.col.type"), cell: (c) => c.type },
                { header: t("campaigns.col.status"), cell: (c) => <CampaignStatus status={c.status} /> },
                { header: t("campaigns.col.contacts"), cell: (c) => format.number(c.contacts) },
                { header: t("campaigns.col.started"), cell: (c) => (c.started_at ? format.dateTime(c.started_at) : "—") },
              ]}
            />
          )
        }
      </Section>
    </Page>
  );
}
